module.exports = __webpack_public_path__ + "img/Tete_a_tete_amoureux.4384d0b.jpg";